module.exports = __webpack_public_path__ + "img/spezialisierungen_960.716e2a69.png";